import {
  GridApi,
  IStatusPanelComp,
  IStatusPanelParams,
} from '@ag-grid-community/core'
import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'

const template = `
  <span class="hs-status-bar">
    <span class="ml-2">Duration Max: </span> <span class="ml-1" id="duration-max-value">0</span>
    <span class="ml-2">Duration AVG: </span> <span class="ml-1" id="duration-avg-value">0</span>
  </span>
`

export class HttpDurationStatusBar implements IStatusPanelComp {
  private api!: GridApi
  private guiElement!: HTMLElement

  /** @internal */
  readonly listener = () => this.onRowDataUpdated()

  init(params: IStatusPanelParams): void {
    this.api = params.api
    params.api.addEventListener('rowDataUpdated', this.listener)
  }

  destroy() {
    this.api.removeEventListener('rowDataUpdated', this.listener)
  }

  getGui(): HTMLElement {
    const el = loadTemplate(template)
    this.guiElement = el
    return el
  }

  /** @internal */
  onRowDataUpdated() {
    let max = 0
    let avg = 0
    let totalDurations = 0
    let durationSum = 0

    this.api.forEachNode(node => {
      const duration: number | undefined = node.data.duration
      if (duration != null) {
        totalDurations++
        durationSum += duration
        if (duration > max) max = duration
      }
    })

    if (totalDurations > 0) avg = Math.round(durationSum / totalDurations)

    const maxSpan = this.guiElement.querySelector(
      '#duration-max-value',
    ) as HTMLElement
    maxSpan.innerText = `${max} ms`

    const avgSpan = this.guiElement.querySelector(
      '#duration-avg-value',
    ) as HTMLElement
    avgSpan.innerText = `${avg} ms`
  }
}
